export const formatChatDate = (value: unknown) => {
  if (typeof value !== "string" || !value) return undefined;
  const [year, month, day] = value.slice(0, 10).split("-");
  return year && month && day ? `${day}/${month}/${year}` : value;
};

export const formatChatTime = (value: unknown) =>
  typeof value === "string" && value ? value.slice(0, 5) : undefined;

export const formatChatYesNo = (value: unknown) =>
  typeof value === "boolean" ? (value ? "Sim" : "Não") : undefined;

export const formatChatActivityType = (value: unknown) =>
  value === "RITUAL" ? "Ritual" : value === "ACTIVITY" ? "Atividade" : undefined;

export const formatChatToggle = (value: unknown) =>
  typeof value === "boolean" ? (value ? "Ativado" : "Desativado") : undefined;

export const formatChatMinutes = (value: unknown) =>
  typeof value === "number" ? `${value} min` : undefined;

export const formatChatText = (value: unknown) =>
  typeof value === "string" || typeof value === "number" ? String(value) : undefined;

export const toStringList = (value: unknown): string[] =>
  Array.isArray(value)
    ? value.filter((item): item is string => typeof item === "string")
    : typeof value === "string" && value
      ? [value]
      : [];

export const toInsumoSelection = (
  value: unknown,
): Array<{ id: string; quantity: number }> =>
  Array.isArray(value)
    ? value.filter(
        (item): item is { id: string; quantity: number } =>
          Boolean(item) && typeof item === "object" && "id" in item,
      )
    : [];

export const CHECKIN_WINDOW_EDIT_FIELDS = new Set([
  "checkinStartWindowMinutes",
  "checkinEndWindowMinutes",
]);
